<template>
  <!-- javni sajt (single): jedna slika loga; tekst "pijace.com" se vidi od 992px (assets/scss/headerLogo.scss) -->
  <div v-if="single" class="navbar-brand-box mt-lg-2">
    <nuxt-link to="/" class="logo logo-dark hl-single">
      <img src="/images/pijace-60.png" alt="Pijace.com – cene na pijacama" width="60" height="60">
      <span class="hl-text text-uppercase ms-2 text-muted font-size-15 fw-bold">pijace.com</span>
    </nuxt-link>
  </div>

  <!-- ostali rasporedi (CMS, profil) koriste teme sa logo-sm / logo-lg / logo-light varijantama -->
  <div v-else class="navbar-brand-box mt-lg-2">
    <nuxt-link to="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="/images/pijace-60.png" alt="logo-sm"
        height="60"
        width="60" />
      </span>
      <span class="logo-lg">
        <img src="/images/pijace-60.png"
        alt="cene na pijacama"
             width="60"
             height="60">
         <span class="text-uppercase ms-2 text-muted font-size-15 fw-bold">pijace.com</span>
      </span>
    </nuxt-link>

    <nuxt-link to="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="/images/pijace-60.png" alt="logo-sm" height="60" width="60" />
      </span>
      <span class="logo-lg">
        <img src="/images/pijace-60.png" alt="logo-light" height="60" width="60"/>
      </span>
    </nuxt-link>
  </div>
</template>

<script setup>
defineProps({
  // jedna slika umesto cetiri (javni sajt)
  single: { type: Boolean, default: false },
})
</script>
